import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Input,
  Popconfirm,
  Row,
  Select,
  Skeleton,
  Space,
  Tree,
  Typography,
  message,
} from "antd"
import React, { useEffect, useState } from "react"
import PageHeader from "../../../../components/Elements/PageHeader"
import { GoFilter } from "react-icons/go"
import { useAuthContext } from "../../../../hooks/useAuthContext"
import { useCollection } from "../../../../hooks/useCollection"
import { db } from "../../../../firebase/config"
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore"
import {
  DeleteOutlined,
  DoubleRightOutlined,
  EditOutlined,
  FolderAddOutlined,
} from "@ant-design/icons"

const { Text, Link } = Typography
const { Meta } = Card
const { DirectoryTree } = Tree

const initValueSPrices = { isLeaf: false }
const initValueSFolders = { isLeaf: true }

export default function PriceFilters() {
  const { user } = useAuthContext()

  //all clients
  const { data, loading } = useCollection("clients", ["user", "==", user.uid])

  //selected client
  const [selectedClient, setSelectedClient] = useState({})
  const [selectedClientLoading, setSelectedClientLoading] = useState(true)

  const [priceData, setPriceData] = useState([])
  const [pricesLoading, setPricesLoading] = useState(false)

  //selected prices
  const [selectedPrices, setSelectedPrice] = useState([initValueSPrices])

  //selected folders
  const [selectedFolders, setSelectedFolder] = useState(initValueSFolders)

  //selected filters
  const [selectedFilters, setSelectedFilters] = useState([])
  const [loadingFilters, setLoadingFilters] = useState(false)

  //new folder name
  const [folderName, setFolderName] = useState("New Folder")

  //price or template state
  const [fetchSource, setFetchSource] = useState("priceCalculation")

  //filter name update
  const [filterNameUpdate, setFilterNameUpdate] = useState("")

  //gets prices
  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      setPricesLoading(true)
      const priceRef = query(
        collection(db, fetchSource),
        where("clientId", "==", selectedClient.id),
        where("hasFilterGroup", "==", false)
      )
      const unsubscribe = onSnapshot(priceRef, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })
        //creates a array of objects for the tree
        const data = results.map((item) => {
          return {
            title: item.product.productName,
            key: item.id,
            isLeaf: true,
          }
        })
        setPriceData([
          {
            title: "products",
            key: 0,
            isLeaf: false,
            children: data,
          },
        ])

        console.log(data)
        setPricesLoading(false)
      })
      return () => unsubscribe()
    }
  }, [selectedClient, fetchSource])

  //gets filters
  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      setLoadingFilters(true)
      const priceRef = query(
        collection(db, "priceFilters"),
        where("clientId", "==", selectedClient.id),
        where("source", "==", fetchSource)
      )
      const unsubscribe = onSnapshot(priceRef, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })
        //creates a array of objects for the tree
        const data = results.map((item) => {
          return {
            title: item.title,
            key: item.id,
            isLeaf: false,
            children: item.children ? item.children.map((child) => child) : [],
          }
        })
        setSelectedFilters(data)
        console.log(data)
        setLoadingFilters(false)
      })
      return () => unsubscribe()
    }
  }, [selectedClient, fetchSource])

  //handle selected client
  const handleClientSelect = (value, options) => {
    setSelectedClient(options)
    setSelectedClientLoading(false)
    //cleanup
    setSelectedFolder({ isLeaf: true })
  }

  //handles price >> filter
  const handleSelectedPriceSelect = (key, data) => {
    setSelectedPrice(data.selectedNodes)
  }

  //handles filter >> prices
  const handleSelectedBack = (key, data) => {
    const objDoc = data.selectedNodes[0]
    setSelectedFolder(objDoc)
    console.log(data)
  }

  //expands the folders
  const onExpand = (data, key) => {
    // console.log(data);
  }

  //update filter name
  const updateFilterName = async () => {
    if (!selectedFolders || Object.keys(selectedFolders).length === 0) {
      return message.error("Select a filter first!")
    }

    if (selectedFolders.isLeaf === true) {
      return message.error("Select a filter first!")
    }

    const ref = doc(db, "priceFilters", selectedFolders.key)

    try {
      // Start a batch write
      const batch = writeBatch(db)

      // Update the filter's title
      batch.update(ref, {
        title: filterNameUpdate,
      })

      // Also update each price that is associated with this filter
      selectedFolders.children.forEach((child) => {
        const priceRef = doc(db, fetchSource, child.key)
        batch.update(priceRef, {
          filterGroup: filterNameUpdate, // Update the filterGroup to the new name
        })
      })

      // Commit the batch write
      await batch.commit().then(() => message.success("Filter Updated!"))
    } catch (err) {
      message.error(err.message)
    }
  }

  //update popconfirm content
  const popConfirmContentName = () => {
    return (
      <>
        <Input
          style={{ width: "100%" }}
          placeholder="enter desired name"
          onChange={(event) => setFilterNameUpdate(event.target.value)}
        />
      </>
    )
  }

  //creates new filter
  const createNewFilter = async () => {
    const ref = collection(db, "priceFilters")

    //set the data for new folder/price filter
    const newFolder = {
      title: folderName,
      created: serverTimestamp(),
      client: selectedClient.client,
      clientId: selectedClient.id,
      uid: user.uid,
      children: [],
      source: fetchSource,
    }

    try {
      await addDoc(ref, newFolder)
        .then(() => setFolderName("New Folder"))
        .then(() => {
          message.success(`Filter added`)
        })
    } catch (err) {
      message.error(err.message)
    }
  }

  //adds prices to the filter
  const addPricesToFilter = async () => {
    //for price check
    const sourceFolder = selectedPrices[0]
    //destination folder
    const destinationFolder = selectedFolders

    //checks if the source folder is not selected
    if (sourceFolder.isLeaf === false || sourceFolder.length === 0) {
      return message.error("You cannot use the whole source folder !")
    } else {
      //if its a price, returns error
      if (destinationFolder.isLeaf === true) {
        return message.error("Please select a destination folder!")
      } else {
        //ref of the folder
        const refId = selectedFolders.key

        //current object
        const currentChildren = selectedFolders.children

        //price to add
        const combinedArray = [...selectedPrices, ...currentChildren]

        const selectedPriceIds = combinedArray.map((item) => {
          return item.key
        })

        console.log(selectedPriceIds)

        //filter ref
        const ref = doc(db, "priceFilters", refId)

        try {
          // updates the combined array
          await updateDoc(ref, {
            children: combinedArray,
          }) //also updates each doc
            .then(() => {
              selectedPriceIds.forEach((element) => {
                updateDoc(doc(db, fetchSource, element), {
                  filterGroup: selectedFolders.title,
                  filterGroupId: selectedFolders.key,
                  hasFilterGroup: true,
                })
              })
            })
            .then(() => {
              message.success("Price added")
            })
        } catch (error) {
          console.log(error.message)
          message.error(error)
        }
      }
    }
  }

  //deletes the current file from filter
  const handleDelete = async (event, node) => {
    event.stopPropagation()
    // console.log(node);
    // Create a new object without the node object
    // Create a new array without the node object
    //gets parent key /id
    let updatedParentKey = null
    //gets new children array
    let updatedChildren = []

    const updatedData = selectedFilters.map((parent) => {
      if (parent.children && parent.children.length > 0) {
        const index = parent.children.findIndex((child) => child.key === node.key)
        if (index !== -1) {
          updatedParentKey = parent.key
          updatedChildren = parent.children.filter((child) => child.key !== node.key)
          return {
            ...parent,
            children: updatedChildren,
          }
        }
      }
      return parent
    })

    console.log(updatedParentKey)
    console.log(updatedChildren)

    const ref = doc(db, "priceFilters", updatedParentKey)

    //updates the docs
    try {
      await updateDoc(ref, {
        children: updatedChildren, //updates the price
      })
        .then(() => {
          updateDoc(doc(db, fetchSource, node.key), {
            filterGroup: null,
            filterGroupId: null,
            hasFilterGroup: false,
          })
        })
        .then(() => {
          message.success("Price added")
        })
    } catch (error) {
      console.log(error.message)
      message.error(error)
    }
  }
  //handles the folder deletion (including prices)
  const handleDeleteFolder = async (event, node) => {
    event.stopPropagation()

    const childrenData = node.children

    try {
      // Delete the folder itself
      await deleteDoc(doc(db, "priceFilters", node.key))
        // Update each doc
        .then(async () => {
          for (const element of childrenData) {
            await updateDoc(doc(db, fetchSource, element.key), {
              filterGroup: null,
              filterGroupId: null,
              hasFilterGroup: false,
            })
          }
        })
        .then(() => {
          //cleanup
          setSelectedFolder({ isLeaf: true })
        })
        .then(() => {
          message.success("Filter deleted!")
        })
    } catch (error) {
      console.log(error.message)
      message.error(error)
    }
  }

  //render popover new filter content
  const popoverContent = () => {
    return (
      <>
        <Input
          placeholder="new folder..."
          onChange={(event) => setFolderName(event.target.value)}
        />
      </>
    )
  }

  //price or template select
  const handlePriceOrTemplate = (value) => {
    setFetchSource(value)
    setSelectedFolder(initValueSFolders)
    setSelectedPrice([initValueSPrices])
    setSelectedClient({})
    setSelectedFilters([])
    setPriceData([])
  }

  //renders custom title so it can be deleted
  const renderTitle = (node) => (
    <>
      {node.title}
      {node.isLeaf && (
        <DeleteOutlined
          style={{ marginLeft: 15, cursor: "pointer" }}
          onClick={(event) => handleDelete(event, node)}
        />
      )}
      {!node.isLeaf && (
        <DeleteOutlined
          style={{ marginLeft: 15, cursor: "pointer" }}
          onClick={(event) => handleDeleteFolder(event, node)}
        />
      )}
    </>
  )

  //options for price or template select
  const tpOptions = [
    {
      value: "priceCalculation",
      label: "Prices",
    },
    {
      value: "priceTemplates",
      label: "Templates",
    },
  ]

  return (
    <div className="page-padding">
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader icon={<GoFilter />} text="Price Filters" />
        </Col>
        <Space direction="vertical">
          <Text>Price or Template?</Text>
          <Select
            defaultValue={fetchSource}
            style={{ width: 600 }}
            options={tpOptions}
            onChange={handlePriceOrTemplate}
          />
        </Space>
        <Col span={24}></Col>
        <Col span={24}>
          <Space direction="vertical">
            <Text>Select Client for Filters :</Text>
            <Select
              showSearch
              onChange={handleClientSelect}
              style={{
                width: 600,
              }}
              loading={loading}
              value={selectedClient.client}
              placeholder="Select client"
              optionFilterProp="children"
              fieldNames={{ value: "id", label: "client" }}
              filterOption={(input, option) => (option?.value ?? "").includes(input)}
              filterSort={(optionA, optionB) =>
                (optionA?.value ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.value ?? "").toLowerCase())
              }
              options={data}
            />
            <Card
              style={{
                width: 600,
              }}
              // actions={[<SettingOutlined key="setting" />, <EditOutlined key="edit" />, <EllipsisOutlined key="ellipsis" />]}
            >
              <Skeleton loading={selectedClientLoading} avatar active>
                <Meta
                  avatar={
                    <Avatar
                      src={
                        "https://firebasestorage.googleapis.com/v0/b/managers-testing.appspot.com/o/systemImages%2Fblank-profile.jpg?alt=media&token=6e6a0663-f5f0-4e6d-b16f-c2fe088bda12"
                      }
                    />
                  }
                  title={selectedClient.client}
                  description={
                    selectedClient.street +
                    ", " +
                    selectedClient.city +
                    ", " +
                    selectedClient.country
                  }
                />
              </Skeleton>
            </Card>
          </Space>
        </Col>
        <Divider />
        <Col flex="600px">
          <Skeleton loading={pricesLoading} active>
            <Card
              style={{
                width: 600,
              }}>
              Product List
              <Divider />
              <DirectoryTree
                multiple
                defaultExpandedKeys={[0]}
                onSelect={handleSelectedPriceSelect}
                onExpand={onExpand}
                treeData={priceData}
              />
            </Card>
          </Skeleton>
        </Col>
        <Col flex="300px">
          <Button onClick={() => addPricesToFilter()} block>
            Add to filter <DoubleRightOutlined />
          </Button>
        </Col>
        <Col flex="600px">
          <Skeleton loading={loadingFilters} active>
            <Card
              style={{
                width: 600,
              }}>
              <Space size={15}>
                <Popconfirm
                  title="Name the filter"
                  description={popoverContent}
                  onConfirm={createNewFilter}>
                  <Link>
                    <FolderAddOutlined /> Add filter
                  </Link>
                </Popconfirm>

                <Popconfirm
                  title="Rename the filter"
                  description={popConfirmContentName}
                  onConfirm={updateFilterName}>
                  <Link>
                    <EditOutlined /> Rename Filter
                  </Link>
                </Popconfirm>
              </Space>

              <Divider />
              <DirectoryTree
                onSelect={handleSelectedBack}
                checkStrictly={true} // Add this line to allow single selection
                treeData={selectedFilters}
                titleRender={renderTitle}
              />
            </Card>
          </Skeleton>
        </Col>
      </Row>
    </div>
  )
}
